var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Voorraad",
      "icon": "pe-7s-note2"
    }
  }), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    staticClass: "mb-4 mb-lg-0",
    attrs: {
      "lg": "6"
    }
  }, [_c('b-card', [_c('b-card-title', [_vm._v("ARTIKEL")]), _c('p', {
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v(" Via onderstaande zoekfunctie kunnen alle voorraadlocaties van een artikel opgevraagd worden. "), _vm.canManageStock ? [_vm._v(" De voorraad kan aangepast worden. Daarmee wordt direct de PBL 2.0 / Smart Logistics Engine database geüpdatet. Let op: Deze voorraden kunnen (en zullen) overschreven worden vanuit de feitelijke voorraadsystemen. ")] : _vm._e()], 2), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.getStockLocationsForProduct.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Vul een volledig artikelnummer in",
      "autofocus": ""
    },
    model: {
      value: _vm.searchProductNumber,
      callback: function ($$v) {
        _vm.searchProductNumber = $$v;
      },
      expression: "searchProductNumber"
    }
  }), _c('OmniButton', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.isLoadingStockLocations
    }
  }, [!_vm.isLoadingStockLocations ? [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.search')))])] : [_c('span', {
    staticClass: "label mr-2"
  }, [_vm._v(_vm._s(_vm.$t('omt.gui.general.action.search')) + "…")]), _c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)]], 2)], 1)], 1)], 1), _vm.showAdditionalProductInformation ? _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_vm.loadedProductNumber ? _c('b-card', {
    key: _vm.loadedProductNumber
  }, [_c('b-card-title', [_vm._v("PRODUCT INFORMATIE")]), _c('product-info', {
    attrs: {
      "number": _vm.loadedProductNumber
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm.isStockLocationsLoaded && !_vm.isLoadingDispatchTypes ? _c('b-card', [_c('b-card-title', [_vm._v("VOORRAADLOCATIES VOOR PRODUCT: " + _vm._s(_vm.loadedProductNumber))]), _c('b-table', {
    attrs: {
      "small": "",
      "fields": _vm.stockTableFields,
      "items": _vm.stockLocations,
      "striped": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "table-colgroup",
      fn: function (scope) {
        return [_c('col', {
          staticStyle: {
            "width": "100px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "auto"
          }
        }), _vm.showShipFromStoreIndicators ? _c('col', {
          staticStyle: {
            "width": "150px"
          }
        }) : _vm._e(), _c('col', {
          staticStyle: {
            "width": "150px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "150px"
          }
        }), _c('col', {
          staticStyle: {
            "width": "150px"
          }
        })];
      }
    }, {
      key: "cell(ship_from_store)",
      fn: function (data) {
        return [_vm.locationShipFromStoreEnabled[data.item.party_identifier] ? _c('font-awesome-icon', {
          staticClass: "text-success font-size-lg",
          attrs: {
            "icon": "circle-check",
            "title": "Ja"
          }
        }) : _c('font-awesome-icon', {
          staticClass: "text-danger font-size-lg",
          attrs: {
            "icon": "circle-xmark",
            "title": "Nee"
          }
        })];
      }
    }, {
      key: "cell(stock_level)",
      fn: function (data) {
        return [_vm.editStockLocation === data.item.party_identifier ? _c('span', [_c('b-input', {
          attrs: {
            "type": "number",
            "min": "0",
            "disabled": _vm.isSavingStockLocation,
            "size": "sm"
          },
          model: {
            value: _vm.newStock,
            callback: function ($$v) {
              _vm.newStock = $$v;
            },
            expression: "newStock"
          }
        })], 1) : _c('span', [_vm._v(_vm._s(data.item.stock_level))])];
      }
    }, {
      key: "cell(stock_level_overrule)",
      fn: function (data) {
        return [_vm.editStockLocation === data.item.party_identifier ? _c('span', [_c('b-input', {
          attrs: {
            "value": _vm.newStockOverrule,
            "type": "number",
            "min": "0",
            "disabled": _vm.isSavingStockLocation,
            "size": "sm"
          },
          on: {
            "input": function ($event) {
              return _vm.onOverruleQuantityInput('newStockOverrule', $event);
            }
          }
        })], 1) : _c('span', [_vm._v(_vm._s(data.item.stock_level_overrule))])];
      }
    }, {
      key: "cell(buttons)",
      fn: function (data) {
        return [_vm.canManageStock && _vm.editStockLocation === null ? _c('OmniButton', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "size": "sm",
            "variant": "primary",
            "icon": "pencil"
          },
          on: {
            "click": function ($event) {
              return _vm.editStock(data.item.party_identifier);
            }
          }
        }, [_vm._v(" Aanpassen ")]) : _vm._e(), _vm.canManageStock && _vm.editStockLocation === data.item.party_identifier ? _c('OmniButton', {
          staticClass: "mr-1",
          attrs: {
            "type": "button",
            "size": "sm",
            "variant": "success",
            "icon": "save",
            "disabled": _vm.isSavingStockLocation
          },
          on: {
            "click": _vm.saveStockLocation
          }
        }, [_vm._v(" Opslaan ")]) : _vm._e(), _vm.canManageStock && _vm.editStockLocation === data.item.party_identifier ? _c('OmniButton', {
          attrs: {
            "type": "button",
            "size": "sm",
            "variant": "danger",
            "icon": "trash",
            "disabled": _vm.isSavingStockLocation
          },
          on: {
            "click": _vm.cancelStock
          }
        }, [_vm._v(" Annuleren ")]) : _vm._e()];
      }
    }], null, false, 4005977842)
  }), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "100px"
    }
  }), _c('col', {
    attrs: {
      "width": "auto"
    }
  }), _c('col', {
    attrs: {
      "width": "100px"
    }
  }), _c('col', {
    attrs: {
      "width": "200px"
    }
  })]), _c('thead', [_c('tr', [_c('th', [_vm._v("Locatie ID")]), _c('th', [_vm._v("Locatie")]), _c('th', [_vm._v("Voorraad")]), _c('th', [_vm._v("Voorraad (overrule)")]), _c('th')])]), _c('tfoot'), _c('tbody', [_c('tr', [_c('td', [_vm.canManageStock ? _c('b-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.isSavingStockLocation,
      "size": "sm"
    },
    model: {
      value: _vm.newStockLocationPartyIdentifier,
      callback: function ($$v) {
        _vm.newStockLocationPartyIdentifier = $$v;
      },
      expression: "newStockLocationPartyIdentifier"
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.newStockLocationPartyIdentifier) + " ")])], 1), _c('td', [_c('i', [_vm._v("Voeg voorraadlocatie toe")])]), _c('td', [_vm.canManageStock ? _c('b-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.isSavingStockLocation,
      "size": "sm"
    },
    model: {
      value: _vm.newStockLocationQuantity,
      callback: function ($$v) {
        _vm.newStockLocationQuantity = $$v;
      },
      expression: "newStockLocationQuantity"
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.newStockLocationQuantity) + " ")])], 1), _c('td', [_vm.canManageStock ? _c('b-input', {
    attrs: {
      "value": _vm.newStockLocationQuantityOverrule,
      "type": "number",
      "min": "0",
      "disabled": _vm.isSavingStockLocation,
      "size": "sm"
    },
    on: {
      "input": function ($event) {
        return _vm.onOverruleQuantityInput('newStockLocationQuantityOverrule', $event);
      }
    }
  }) : _c('span', [_vm._v(" " + _vm._s(_vm.newStockLocationQuantityOverrule) + " ")])], 1), _c('td', [_vm.canManageStock ? _c('OmniButton', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button",
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.isSavingStockLocation || !_vm.isNewStockLocationValid,
      "icon": "circle-plus"
    },
    on: {
      "click": _vm.saveNewStockLocation
    }
  }, [_vm._v(" Toevoegen ")]) : _vm._e(), _vm.isNewStockLocationAlreadyInList ? _c('span', [_vm._v(" Locatie ID staat al in de lijst! ")]) : _vm._e()], 1)])])])], 1) : _vm.loadedProductNumber && !_vm.isLoadingStockLocations ? _c('b-card', [_c('b-card-title', [_vm._v("VOORRAADLOCATIES VOOR PRODUCT: " + _vm._s(_vm.loadedProductNumber))]), _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(" Product niet gevonden ")])], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }